import type { PaymentRunReviewLockRowState } from './payment-run-review.types';

export function isPaymentRunRowSelectedForLock(
  state: PaymentRunReviewLockRowState,
): boolean {
  try {
    return (
      state.lockSelectionIds.includes(state.invoiceId) ||
      (state.incrementalLockAllowed &&
        state.approvedForRunSet.has(String(state.invoiceId).trim()))
    );
  } catch (error) {
    console.error('Failed to decide if a payment run row is selected', {
      invoiceId: state.invoiceId,
      error,
    });
    throw error;
  }
}

export function isPaymentRunRowLockDisabled(
  state: PaymentRunReviewLockRowState,
): boolean {
  try {
    return (
      !state.lockableIds.has(state.invoiceId) ||
      state.lockInteractionsDisabled ||
      (state.incrementalLockAllowed &&
        state.approvedForRunSet.has(String(state.invoiceId).trim()))
    );
  } catch (error) {
    console.error('Failed to decide if a payment run lock checkbox is disabled', {
      invoiceId: state.invoiceId,
      error,
    });
    throw error;
  }
}
